import { Box, Popover, Typography, useTheme } from "@mui/material";
import { useState, useRef } from "react";
import { HexColorPicker } from "react-colorful";
import { tokens } from "../../../../theme";

interface Props {
  label: string;
  value: string;
  onChange: (color: string) => void;
}

const ColorPicker = ({ label, value, onChange }: Props) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const ref = useRef<HTMLDivElement>(null);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode)

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Typography variant="caption" color="white" fontWeight={600}>
        {label}
      </Typography>
      <Box
        ref={ref}
        onClick={() => setAnchor(ref.current)}
        sx={{
          width: 32,
          height: 32,
          borderRadius: "50%",
          bgcolor: value || colors.primary[800],
          border: "2px solid rgba(255,255,255,0.4)",
          cursor: "pointer",
          transition: "transform 0.15s",
          "&:hover": { transform: "scale(1.1)" },
        }}
      />
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{ paper: { sx: { p: 1.5, borderRadius: 2 } } }}
      >
        <HexColorPicker color={value || colors.primary[700]} onChange={onChange} />
        <input
          type="text"
          value={value}
          onChange={(e) => {
            if (/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(e.target.value)) {
              onChange(e.target.value);
            }
          }}
          placeholder="#000000"
          style={{
            width: "100%",
            marginTop: 8,
            padding: "6px 10px",
            borderRadius: 6,
            border: `1px solid ${colors.primary[800]}`,
            fontFamily: "monospace",
            fontSize: 13,
            textAlign: "center",
          }}
        />
      </Popover>
    </Box>
  );
};

export default ColorPicker;
